import AutoComplete from "@tarekraafat/autocomplete.js";
import API from "./api";

export function initAutocomplete(node, field) {

    const autocompleteField = new AutoComplete({
        selector: () => node,
        data: {
            src: async (query) => {
                try {
                    const results = await API.autocomplete(field, query);

                    return results.terms;
                } catch (error) {
                    return error;
                }
            }
        },
        searchEngine: (query, record) => searchEngine(query, record, autocompleteField),
        resultsList: {
            element: (list, data) => {
                if (!data.results.length) {
                    // Create "No Results" message element
                    const message = document.createElement("div");
                    // Add class to the created element
                    message.setAttribute("class", "autoComplete_no-result");
                    // Add message text content
                    message.innerHTML = `<span>Nessun risultato trovato per "${data.query}"</span>`;
                    // Append message element to the results list
                    list.prepend(message);
                }
            },
            maxResults: 10,
            noResults: true,
        },
        resultItem: {
            highlight: {
                render: true
            }
        },
        debounce: 300
    });

    autocompleteField.input.addEventListener("selection", (event) => onAutocompleteSelection(node, event, autocompleteField));
}

function onAutocompleteSelection(node, event, autoCompleteJS) {
    const feedback = event.detail;
    autoCompleteJS.input.blur();
    /*
     * Prepare User's Selected Value
     */
    const selection = feedback.selection.value;
    /*
     * Render selected choice to selection div
     */
    document.querySelector(".selection").innerHTML = selection;
    /*
     * Replace Input value with the selected value
     */
    // autoCompleteJS.input.value = selection;
    node.dispatchEvent(new CustomEvent("selected", {detail: selection}));
}

function searchEngine(query, record, autoCompleteJS) {
    return autoCompleteJS.search(query, record, {
                mode: 'strict',
                highlight: true
            }) || record;
}